import { render } from "./SampleProjects.vue?vue&type=template&id=7a2dac0b&scoped=true"
import script from "./SampleProjects.vue?vue&type=script&lang=js"
export * from "./SampleProjects.vue?vue&type=script&lang=js"

import "./SampleProjects.vue?vue&type=style&index=0&id=7a2dac0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2dac0b"]])

export default __exports__